const LocalStorageConstant: any = {
  accessToken: "access_token",
  refreshToken: "refresh_token",
};

export default LocalStorageConstant;
